import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../../login-service';
import Swal from 'sweetalert2';

import { AlertConfig } from 'ngx-bootstrap/alert';


export function getAlertConfig(): AlertConfig {
  return Object.assign(new AlertConfig(), { type: 'success' });
}


@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
  providers:[{ provide: AlertConfig, useFactory: getAlertConfig }]
})
export class LocationComponent implements OnInit {
  add:boolean=true;
  add1:boolean=true;
  countryname:any;
  isSubmit:boolean=false;
  locId:any;
  roleID:string;
  countryName:any;
  stateName:any;
  cityName:any;
  addLocation:boolean=false;
  locationsList:any=[];
  locationsListdetails:any=[];
  message:any;
  type:any;
  viewed:boolean=false;
  errorMessage:string;
  viewLocations:any;
  userType
  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  searchWord: string = "";
  pagedItems: any;
  SearchList:any;
  
  currentpage: number=1;
  menuData:any;
  searchText: any;
  rolesList: any;
  MenuPermissions: any;
  userID:string;
  menuName: any;
  menuID: any;
  CountriesList: any;
  statesList: any;
  citiesList: any;
  filteredstatesList: any;
  filteredcitiesList: any;
  enableSkipWelcome: boolean=false;
  checked:boolean=false;
  countrycode: any;
  statename: any;
  id: any;
  countrycode1: any;
  countryid: any;
  selectedlocListid=[]
  dynamicRows: number;
  rowsOnPageSet: any[];
  rowCount: any;
  rowsOnPage: any;
  p:any;
  count:any;
 savefilter: any;
  matcountry: boolean=false;
  stateselect: boolean=false;
  countryselect: boolean=false;
  constructor(private loginService:LoginService) {
    this.userID=localStorage.getItem("userID");
    this.roleID=localStorage.getItem("roleID");
    // this.menuData=localStorage.getItem("menuData");
    this.MenuPermissions=localStorage.getItem("MenuPermissions");
    this.userType=localStorage.getItem("userTypeid");
  
    this.GetMenusByUserType(3);
   
   }

  ngOnInit(): void {
    this.loginService.getselectpage(10)
    this.getLocations();
    this.GetRoles();
 this.getCountries();
   this.getStatenames();
  
  }
  GetRoles(){
    this.loginService.GetRoles(this.userType).subscribe(data=>
      {  
              this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
  let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())

  if(filteRole.length>0){
    this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);
    
  }
  });
  }

  addbutton()
  {
this.add=false;
  }
  addbutton1()
  {
this.add1=false;
  }
  cancel1()
  {
    this.add=true;
  }
  GetMenusByUserType(userTypeID){
    this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
        {
    
    this.menuData=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
   
    
    let tempdata=this.menuData;
    
    this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='location');
   
    if(this.menuData.length>0)
      {
    this.menuName=this.menuData[0]["menu_name"];
    this.menuID=this.menuData[0]["menu_id"];
      }
    

      
    
        });
        }
        changepagination(page:number){
          this.count=this.rowsOnPage
          console.log(this.rowsOnPage)
          this.loginService.getselectpage(this.rowsOnPage)
          this.loginService.getPager(this.locationsListdetails.length, page);
          this.setPage(page)
        }
  setPage(page: number) {

   this.p=page;
    this.pager = this.loginService.getPager(this.locationsListdetails.length, page);
    this.pagedItems = this.locationsListdetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.count=this.pager.pageSize
    this.locationsList = this.locationsListdetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  
}

Searchtext(){
    this.locationsList = this.savefilter;
 
        let tempCompany = this.locationsList.filter(
          (item) => {
            return (
              (item.country !== null && item.country.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
              (item.state !== null && item.state.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
              (item.city !== null && item.city.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
            );
          }
    
        );
        this.locationsList = tempCompany;
        this.assigndynamicarray(tempCompany)
        // if(this.searchText==""){
        //   this.getLocations();
        //   this.assigndynamicarray(this.locationsList)
        // }
        if(this.searchText !== ""){
          this.locationsListdetails = tempCompany;
          this.setPage(1);
      }else{
          this.locationsListdetails = this.savefilter;      
          this.assigndynamicarray(this.locationsList)
    
          this.setPage(1);
      }
    
  }
  /*Display add location form*/
  AddLocation(){
    this.countryName='';
    this.stateName='';
    this.cityName='';
    this.addLocation=true;
    this.type="New";
    
  }
  
/* Retrieve location records from the database*/
  getLocations(){
    
    this.loginService.GetLocations(this.userType).subscribe(data=>
      {
        this.locationsList = JSON.parse(data['_body']);
        this.locationsListdetails=this.locationsList;
        this.savefilter=this.locationsListdetails
        this.assigndynamicarray(this.locationsList)
        if(this.locationsListdetails.length>0){
          this.setPage(1);
        }
      });
   
 }
 assigndynamicarray(userslist)
 {
   this.dynamicRows=10
   this.rowsOnPageSet=[];
   this.rowCount = userslist.length;
   console.log(this.rowCount,this.dynamicRows)
   while (this.dynamicRows < this.rowCount) {
     this.rowsOnPageSet.push(this.dynamicRows);
     this.dynamicRows = this.dynamicRows + 10;
     console.log(this.rowsOnPageSet)
   }
   if (!this.rowsOnPageSet.includes(this.rowCount))
     this.rowsOnPageSet.push(this.rowCount);
   if (this.rowsOnPageSet.length === 1) {
     if (this.rowsOnPageSet[0] <= 10)
       this.rowsOnPage = this.rowsOnPageSet[0];
   }
   this.rowsOnPage = this.rowsOnPageSet[0];
 }
 getCountries(){
    
  this.loginService.GetCountries().subscribe(data=>
    {
      this.CountriesList = JSON.parse(data['_body']);
    });
 
}

getStatenames(){
this.loginService.GetStates().subscribe(data=>
  {
    this.statesList = JSON.parse(data['_body']);
  })
}
SkipWelcomePage(event) {
  this.enableSkipWelcome = event.checked;
  this.checked=this.enableSkipWelcome;
}
getCounr(event){
  console.log(this.countryName)
  this.matcountry=true;
  this.add1=false;
  let id=event.target.value;
  this.countryName=event.target.value;
  console.log(this.countryName)

  this.loginService.GetStates().subscribe(data=>
    {
      this.statesList = JSON.parse(data['_body']);
      
      let countryname=this.CountriesList.filter(x=>x.id==id);
      
      this.filteredstatesList=this.statesList.filter(x=>x.country_id==id);
      
    })
}
getCountr(){
  console.log(this.countryName)
  this.countryselect=true;
    this.add1=true;
  this.loginService.GetStates().subscribe(data=>
    {
      this.statesList = JSON.parse(data['_body']);
      
      let countryname=this.CountriesList.filter(x=>x.id==this.countryName);
      
      this.filteredstatesList=this.statesList.filter(x=>x.country_id==this.countryName);
      
    })
}
  getStates(event){
    this.stateselect=true;
    this.add=true
    let id=event.target.value;
    let name=event.target.name;
    
    this.loginService.GetStates().subscribe(data=>
      {
        this.statesList = JSON.parse(data['_body']);
       
        let countryname=this.CountriesList.filter(x=>x.id==id);
        
        this.filteredstatesList=this.statesList.filter(x=>x.country_id==id);
        
      })
    }
    getCities(event){
    
    let id=event.target.value;
    let name=event.target.name;
  this.loginService.GetCities().subscribe(data=>
    {
      this.citiesList = JSON.parse(data['_body']);
      
      let statename=this.statesList.filter(x=>x.id==id);
        
        this.stateName=statename[0].name;
        
      this.filteredcitiesList=this.citiesList.filter(x=>x.state_id==id);
     
    })
  }
citiesName(event){
  let id=event.target.value;
  let name=event.target.name;
  let cityname=this.citiesList.filter(x=>x.id==id);
       
        this.cityName=cityname[0].name;
        
}
cancel()
{
  this.add1=true;
}
Insertcountries()
{
  if(this.countryName==""||this.countryName==undefined||this.countrycode==""||this.countrycode==undefined){return;}
  const json={
    countryparm:this.countryname,
    codeparm:this.countrycode,
    flag:"1"

  };
  // if(this.countryname!=null)
  // {
  //  this.CountriesList.push(JSON.parse(this.countryname));
  // }
  this.loginService.SaveCountries(json).subscribe((dataJson) => {
   
    if (dataJson['_body'].toString() === 'true') {
     
      // Swal.fire("Saved Successfully");
      this.loginService.showSuccess("Saved Successfully","");
      this.countryname="";
      this.countrycode="";
      this.add1=true;
       setTimeout(() => {
         this.message = "";
       }, 5000);
       
    this.getCountries();
    
  }
 this.getCountries();
    });
} 

Insertstates()
{
  if(this.statename==""||this.statename==undefined||this.countrycode1==""||this.countrycode1==undefined){return;}
  this.loginService.GetCountries().subscribe(data=>
    {
      this.CountriesList = JSON.parse(data['_body']);
      
    });
     this.countryid=this.CountriesList.filter(x=>x.code==this.countrycode1);
  const json={
    stateparm:this.statename,
    codeparm:this.countrycode1,
    countryid:this.countryid[0].id
  };
  // if(this.statename!=null)
  // {
  //  this.filteredstatesList.push(JSON.parse(this.statename));
  // }
  this.loginService.Savestates(json).subscribe((dataJson) => {
   
    if (dataJson['_body'].toString() === 'true') {
     
      // Swal.fire("Saved Successfully");
      this.loginService.showSuccess("Saved Successfully","");
      this.statename="";
      this.countrycode1="";
      this.add=true;
       setTimeout(() => {
         this.message = "";
       }, 5000);
       
    this.getCountries();
    
  }
 this.getCountries();
    });
}

/*Save and update locations in the database*/
 saveLocations(){
  this.countryid=this.CountriesList.filter(x=>x.code==this.countrycode1);
  const json={
    locationid:this.locId,
    countryparm:this.countryName,
   stateparm:this.stateName,
   cityparm:this.cityName,
   createdbyparm:'Admin',
   updatedbyparm:"Admin"
  };
  if(this.countryName ===''|| this.countryName === undefined){
   
    return;
   }
   
  if(this.stateName ===''|| this.stateName === undefined){
    
    return;
   }

   
  if(this.cityName.trim() ===''|| this.cityName === undefined){
   
    return;
   }

  this.loginService.SaveLocations(json).subscribe((dataJson) => {
   
   if (dataJson['_body'].toString() === 'true') {
    
    if(this.type== "New"){
     // Swal.fire("Saved Successfully");
     this.loginService.showSuccess("Saved Successfully","");
      setTimeout(() => {
        this.message = "";
      }, 5000);
      }
      else if(this.type==="Edit"){
       // Swal.fire("Updated Successfully");
        this.loginService.showSuccess("Updated Successfully","");
        this.addLocation=false;
      }
   this.getLocations();
   //this.setPage(1);
   if(this.type==="New"){
     this.countryName="";
     this.stateName="";
     this.cityName="";
   }
 }
this.getLocations();
   });
  
  
}

edit(row){
  console.log(row)
  this.type="Edit";
  this.addLocation=true;
this.locId=row.locationid;

  this.countryName=row.countryid;
console.log(this.countryName)
  this.loginService.GetStates().subscribe(data=>
    {
      this.statesList = JSON.parse(data['_body']);
     
      this.filteredstatesList=this.statesList.filter(x=>x.country_id==this.countryName);

    })
  this.stateName=row.state;
  
  this.cityName=row.city;
}
/*View the location details in the form*/
view(row){

  this.type="View";
  this.addLocation=true;
  this.viewed=true;
  this.countryName=row.country;
  this.stateName=row.state;
  this.cityName=row.city;
}
cancelLocations(){
  this.addLocation=false;
}
selectRow(id,e){
  if(e.target.checked){
   this.checked=true;;
   this.selectedlocListid.push(e.target.id)
  }
  else{
   var index = this.selectedlocListid.indexOf(e.target.id);
  this.checked=false;
  this.selectedlocListid.splice(index,1)
  }
}
DeleteSelected(){
 if(this.selectedlocListid.length==0){
   return;
 }
 else{
   event.stopPropagation();
   Swal.fire({
     title: 'Are you sure?',
     text: 'You want to delete the selected rows' ,///
     icon: 'warning',
     showCancelButton: true,
     confirmButtonText: 'Yes',
     cancelButtonText: 'No'
   }).then((result) => {
     if (result.value) {
       this.deleterows(this.selectedlocListid);//
     } else if (result.dismiss === Swal.DismissReason.cancel) {
 
     }
   })
 }
}
deleterows(list){
for(var i=0;i<list.length;i++){
 this.delete(list[i],'d');
 this.selectedlocListid=[];
}
}
/* Delete a record from the location table by passing its id*/
deleteloc(row,isactive,text){
  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to '+text+' this location:' + row.city,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(row.locationid,isactive);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })

}

delete(ID,isactive) {
  const json={
    locationid:ID,
    isactive:isactive
  }
  this.loginService.DeleteLocations(json).subscribe(data => {
 if(isactive=='d'){
  this.loginService.showSuccess("Deleted Successfully","");

}
else if(isactive=='y'){
this.loginService.showSuccess("Activated Successfully","");

}
else{
this.loginService.showSuccess("Deactivated Successfully","");

}
    this.getLocations();
    setTimeout(() => {
      this.message = "";
    }, 1000);
  // this.getFares();
  // this.setPage(1);
  })
}


}
